export enum RestrictionType {
    All,
    Concepts,
    Published,
    PublishedCollections,
    Deleted,
    Archived
}
